module.exports = __webpack_public_path__ + "img/color_map.3234e9e8.webp";